import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import PageBanner from "@/components/PageBanner";
import { Footprints, Binoculars, TreePine, Users } from "lucide-react";

const features = [
  {
    icon: Footprints,
    title: "Extensive Habitats",
    description: "17,000 km² of gorilla habitat in Bwindi Impenetrable National Park and Mgahinga Gorilla National Park in Uganda"
  },
  {
    icon: Binoculars,
    title: "Chimpanzee Tracking",
    description: "Over 5,000 chimpanzees in Kibale National Park, Budongo Forest, and Kyambura Gorge in Uganda"
  },
  {
    icon: TreePine,
    title: "Multi-Country Experience",
    description: "Trek mountain gorillas in Volcanoes National Park, Rwanda, and explore the Gombe Stream National Park in Tanzania"
  },
  {
    icon: Users,
    title: "Diverse Primates",
    description: "13 primate species, including monkeys, baboons, and colobus monkeys"
  }
];

export default function GorillaPrimateTrekking() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Gorilla & Primate Trekking | Ecoplace Tours</title>
        <meta
          name="description"
          content="Join our expert guides on an unforgettable gorilla and primate trekking adventure across East Africa's most spectacular primate habitats."
        />
      </Helmet>

      <PageBanner
        title="Gorilla & Primate Trekking"
        description="Join our expert guides on an unforgettable gorilla and primate trekking adventure. With extensive knowledge of Uganda's, Rwanda's, and Tanzania's primate habitats, our guides ensure a safe and exhilarating experience."
  backgroundImage="/gorilla.webp"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-xl shadow-lg p-6"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 bg-primary/10 rounded-lg">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">
                  {feature.title}
                </h3>
              </div>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 text-center"
        >
          <p className="text-lg text-black-600 max-w-3xl mx-auto font-bold">
            Experience the thrill of encountering our closest animal relatives in their natural habitat with our expert guides who ensure both your safety and an unforgettable adventure.
          </p>
        </motion.div>
      </div>
    </div>
  );
}
